export const SHOW_EXIT_POLL = 'SHOW_EXIT_POLL';
export const HIDE_EXIT_POLL = 'HIDE_EXIT_POLL';

export const EXIT_POLL_ANSWER = 'EXIT_POLL_ANSWER';
export const answerExitPoll = (answer) => ({
    type: EXIT_POLL_ANSWER,
    value: answer
});

export const EXIT_POLL_ANSWER_SAVE_SUCCEED = 'EXIT_POLL_ANSWER_SAVE_SUCCEED';
